import { render, staticRenderFns } from "./r-map-kind-page.vue?vue&type=template&id=240a36cd&scoped=true&class=map-kind-page"
import script from "./r-map-kind-page.vue?vue&type=script&lang=js"
export * from "./r-map-kind-page.vue?vue&type=script&lang=js"
import style0 from "./r-map-kind-page.vue?vue&type=style&index=0&id=240a36cd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240a36cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240a36cd')) {
      api.createRecord('240a36cd', component.options)
    } else {
      api.reload('240a36cd', component.options)
    }
    module.hot.accept("./r-map-kind-page.vue?vue&type=template&id=240a36cd&scoped=true&class=map-kind-page", function () {
      api.rerender('240a36cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-kind/r-map-kind-page.vue"
export default component.exports